import { render, staticRenderFns } from "./PendingApprovalInsuranceModal.vue?vue&type=template&id=ef6e5e30"
import script from "./PendingApprovalInsuranceModal.vue?vue&type=script&lang=js"
export * from "./PendingApprovalInsuranceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports